// src/lib/riskCalc.ts
import type { RAG } from '../types/risk.type';

export const calcScore = (p?: number | null, i?: number | null) => (p && i ? p * i : null);

export const ragFromScore = (score: number | null): RAG | null => {
    if (score == null) return null;
    if (score >= 15) return 'R';
    if (score >= 8) return 'A';
    return 'G';
};
